<template>
    <textarea class="form-control"></textarea>
</template>
<script>
import $ from "jquery";
import "summernote";
export default {
    name: "summernote",
    props: {
        value: {
            required: true,
        },
        height: {
            type: String,
            default: "150",
        },
    },

    mounted() {
        let config = {
            height: this.height,
            toolbar: [
                // [groupName, [list of button]]
                ["style", ["bold", "italic", "underline", "clear"]],
                ["font", ["strikethrough"]],
                ["fontsize", ["fontsize"]],
                ["para", ["ul", "ol", "paragraph"]],
                ["misc", ["codeview", "fullscreen"]],
            ],
        };
        let vm = this;
        config.callbacks = {
            onInit: function () {
                $(vm.$el).summernote("code", vm.value);
            },
            onChange: function () {
                vm.$emit("input", $(vm.$el).summernote("code"));
            },
            onBlurCodeview: function (contents, $editable) {
                vm.$emit("input", $(vm.$el).summernote("code"));
            },
        };
        $(this.$el).summernote(config);
    },
    beforeUnmount() {
        $(this.$el).summernote("destroy");
    },
};
</script>
